export const GET_TEAM_PROFILE_SUCCESS = "GET_TEAM_PROFILE_SUCCESS";
export const GET_TEAM_PROFILE_REQUEST = "GET_TEAM_PROFILE_REQUEST";
export const GET_TEAM_PROFILE_ERROR = "GET_TEAM_PROFILE_ERROR";
export const GET_PLAYER_TEAM_INFO_REQUEST = 'GET_PLAYER_TEAM_INFO_REQUEST';
export const GET_PLAYER_TEAM_INFO_SUCCESS = 'GET_PLAYER_TEAM_INFO_SUCCESS';
export const GET_PLAYER_TEAM_INFO_ERROR = 'GET_PLAYER_TEAM_INFO_ERROR';
